import { render, staticRenderFns } from "./contacts-profile.vue?vue&type=template&id=74a2f166&"
import script from "./contacts-profile.vue?vue&type=script&lang=js&"
export * from "./contacts-profile.vue?vue&type=script&lang=js&"
import style0 from "./contacts-profile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports